// The Freaks strings — copied 1:1 from mobile translations/pl.json (theFreaks + its settings keys).
// Keep in sync with mobile: same keys, same %{param} placeholders.
export default {
  "theFreaks": {
    "profile": {
      "notPlaying": "Jeszcze nie grasz — dotknij, aby zacząć zdobywać respekt",
      "toNextLevel": "%{respect} respektu do Lvl %{level}",
      "seasonRank": "Miejsce w sezonie",
      "record": "%{missions} misji · %{won} wygr. · %{lost} przegr.",
      "maxLevel": "Najwyższy poziom — jesteś freakiem na poz. %{level}!"
    },
    "title": "The Freaks",
    "homeButton": "Freaks",
    "botBadge": "BOT",
    "botA11y": "Gracz komputerowy, nie prawdziwa osoba",
    "homeButtonA11y": "Otwórz grę The Freaks",
    "tagline": "Rób swoje, zdobywaj respekt, wejdź na szczyt",
    "level": "Poz. %{level}",
    "levelMax": "Poz. %{level} · MAX",
    "power": "Moc",
    "respect": "Respekt",
    "cash": "Kasa",
    "energy": "Energia",
    "nextEnergy": "+1 za %{time}",
    "energyFull": "Pełna",
    "playAs": "Grasz jako",
    "pickContext": "Wybierz aktywność",
    "pickContextHint": "Misje, sprzęt i baza zależą od aktywności. Kupiony sprzęt zostaje przy swojej aktywności.",
    "refill": "Przekąska przy ognisku +%{energy}",
    "refillPrice": "%{price} kasy · zostało dziś: %{left}",
    "recoveryTitle": "Kontuzja — regeneracja",
    "recoveryText": "Misje i wyzwania wrócą za %{time}",
    "recoverButton": "Podlecz się za %{price}",
    "rulesTitle": "Jak grać",
    "rules": "Energia odnawia się sama (+1 co 3 min). Wydawaj ją na misje, żeby zdobywać kasę i respekt. Każda statystyka ma swoją rolę: Technika do misji, Siła do wyzwań, Wytrzymałość do obrony (i krótszych kontuzji), Charyzma do zarobków bazy. Lepszy sprzęt i poziomy bazy odblokowujesz wraz z poziomem — aż do poziomu 100. Zbuduj bazę, która zarabia, gdy Cię nie ma. Wyzywaj innych freaków i zabieraj im część kasy. Nowi gracze są chronieni przez pierwsze 7 dni (albo do 200 respektu) i mogą wyzywać tylko boty. Odbieraj codzienną nagrodę — 3 najlepszych freaków każdego dnia wygrywa prawdziwe Freak Points. Wykonuj 3 codzienne zadania (jedno naprawdę we Freakland). Sprawdzaj dzisiejsze wydarzenie. Naprawiaj zużytą bazę i trzymaj kasę w sejfie. Top 10 każdego miesiąca i najlepsi w każdej aktywności dostają medale. Gracze oznaczeni BOT to gracze komputerowi: ożywiają grę, można ich wyzywać jak każdego i nigdy nie wygrywają Freak Points. Każda aktywność ma własnego freaka, który z poziomem przechodzi 12 etapów — od żółtodzioba do legendy, a potem aż do bóstwa z poziomu 100.",
    "daily": {
      "title": "Dzienna nagroda",
      "streak": "Dzień %{streak} z 7",
      "prize": "%{cash} kasy + %{energy} energii",
      "points": "+%{points} FP",
      "claim": "Odbierz",
      "bonusOn": "Freak bonus: podwójna kasa za dzisiejszy wpis 🔥",
      "bonusTip": "Opublikuj dziś freaka, a kasa będzie podwójna",
      "claimed": "Nagroda odebrana. Wróć jutro, żeby nie stracić serii!"
    },
    "tabs": {
      "missions": "Misje",
      "train": "Trening",
      "gear": "Sprzęt",
      "base": "Baza",
      "fight": "Walka",
      "top": "Top Freaks",
      "today": "Dziś we Freakland",
      "friends": "Znajomi",
      "quests": "Zadania"
    },
    "quests": {
      "intro": "Codziennie 3 nowe zadania: dwa w grze i jedno, które robisz naprawdę we Freakland. Ukończ je i dotknij \"Odbierz\".",
      "names": {
        "missions": "Wygraj %{goal} misje",
        "bigMission": "Wygraj misję poziomu 3+",
        "challenge": "Wygraj wyzwanie",
        "train": "Trenuj %{goal} razy",
        "collect": "Zbierz kasę z bazy",
        "realFreak": "Opublikuj dziś freaka",
        "realTrack": "Nagraj dziś trasę",
        "realCatch": "Zapisz dziś połów",
        "realReel": "Dodaj dziś rolkę"
      },
      "realHint": "Zrób to we Freakland — zaliczy się samo",
      "reward": "+%{cash} kasy · +%{respect} respektu",
      "points": "+%{points} FP",
      "claim": "Odbierz",
      "claimed": "Odebrane"
    },
    "awards": {
      "title": "Moje medale i odznaki",
      "hint": "Medale dla top 10 każdego miesiąca i najlepszych w każdej aktywności (top 3 wygrywa 100 / 50 / 25 FP). Odznaki za serie, misje i znajomych, którzy dołączą.",
      "empty": "Jeszcze nic — skończ miesiąc w top 10 albo utrzymaj serię.",
      "names": {
        "season1": "Mistrz sezonu",
        "season2": "Wicemistrz sezonu",
        "season3": "3. miejsce w sezonie",
        "seasonTop10": "Top 10 sezonu",
        "activityChampion": "Najlepszy w aktywności",
        "dailyChampion": "Mistrz dnia",
        "streak30": "Seria 30 dni",
        "winStreak5": "5 wygranych z rzędu",
        "winStreak10": "10 wygranych z rzędu",
        "missions100": "100 misji",
        "missions1000": "1000 misji",
        "recruiter": "Werbownik",
        "other": "Nagroda"
      }
    },
    "world": {
      "title": "Dziś we Freakland",
      "payday": "Dzień wypłaty: misje dają 25% więcej kasy",
      "luckyDay": "Szczęśliwy dzień: +10% szans w każdej misji",
      "trainingCamp": "Obóz treningowy: trening 25% taniej",
      "fightNight": "Noc walk: wygrane wyzwania dają 50% więcej",
      "boomingBusiness": "Hossa: bazy zarabiają 50% więcej",
      "hotActivity": "Gorąca aktywność: %{context} — jej misje dają 50% więcej respektu"
    },
    "safe": {
      "title": "Sejf",
      "balance": "%{cash} / %{capacity} kasy w środku",
      "hint": "Kasy w sejfie nie da się zabrać w wyzwaniu. Wpłata kosztuje %{fee}%, wypłata jest darmowa, +%{interest}% odsetek z każdym nowym miesiącem. Mieści więcej wraz z Twoim poziomem.",
      "depositAll": "Wpłać wszystko",
      "withdrawAll": "Wypłać wszystko"
    },
    "missions": {
      "go": "Start",
      "tier": "Poziom %{tier}",
      "chance": "%{chance}% szans",
      "reward": "~%{cash} kasy · +%{respect} respektu",
      "locked": "Odblokujesz przy %{respect} respektu",
      "energy": "%{energy} energii",
      "repeat": "Powtórz ×%{times}",
      "showLocked": "Pokaż zablokowane misje (%{count})",
      "hideLocked": "Ukryj zablokowane misje"
    },
    "stats": {
      "strength": "Siła",
      "skill": "Technika",
      "endurance": "Wytrzymałość",
      "charisma": "Charyzma"
    },
    "statHints": {
      "strength": "Główna statystyka, gdy kogoś wyzywasz",
      "skill": "Główna statystyka w misjach",
      "endurance": "Główna statystyka, gdy ktoś Cię wyzywa · krótsze kontuzje",
      "charisma": "+1% zarobków bazy za każdy punkt"
    },
    "statEffects": {
      "endurance": "Kontuzje krótsze o %{percent}%",
      "charisma": "Zarobki bazy +%{percent}%"
    },
    "train": {
      "button": "Trenuj",
      "cost": "%{price} kasy · %{energy} energii",
      "withGear": "%{value} ze sprzętem",
      "powers": "Moc · Misje %{missions} · Atak %{attack} · Obrona %{defense}",
      "powersHint": "Każda akcja liczy swoją główną statystykę podwójnie. Trenuj równo albo się specjalizuj."
    },
    "gear": {
      "buy": "Kup · %{price}",
      "owned": "Masz",
      "bonus": "+%{bonus} %{stat}",
      "locked": "Odblokujesz na poz. %{level}",
      "showLocked": "Pokaż zablokowany sprzęt (%{count})",
      "hideLocked": "Ukryj zablokowany sprzęt"
    },
    "base": {
      "level": "Poziom %{level}/%{max}",
      "notBuilt": "Jeszcze nie zbudowana — zarabia, gdy Cię nie ma",
      "income": "%{income} kasy / godz.",
      "waiting": "Czeka: %{cash} kasy (mieści %{hours} h)",
      "collect": "Zbierz",
      "build": "Zbuduj · %{price}",
      "upgrade": "Rozbuduj · %{price}",
      "nextIncome": "Następny poziom: %{income} kasy / godz.",
      "maxed": "Maksymalny poziom",
      "condition": "Stan %{condition}%",
      "worn": "Zużyta — zarabia mniej. Napraw ją!",
      "repair": "Napraw · %{price}",
      "locked": "Następny poziom odblokujesz na poz. %{level}"
    },
    "fight": {
      "intro": "Wyzwij freaka o podobnym respekcie. Wygrasz — zabierasz 10% jego kasy. Każdego freaka można wyzwać najwyżej 3 razy dziennie. Wyzywasz tego samego freaka częściej niż 3 razy w tygodniu — łup maleje.",
      "challenge": "Wyzwij",
      "cost": "%{energy} energii",
      "record": "Wygrane %{won} · Przegrane %{lost}",
      "empty": "Nie ma teraz kogo wyzwać — wróć później.",
      "refresh": "Szukaj innych",
      "loot": "%{percent}% łupu",
      "newcomer": "🛡️ Ochrona nowicjusza do %{date}: nikt nie może Cię wyzwać, a Ty możesz wyzywać tylko boty. Kończy się wcześniej przy 200 respektu."
    },
    "top": {
      "season": "Ten miesiąc",
      "today": "Dziś",
      "all": "Wszech czasów",
      "allContexts": "Wszystkie",
      "myRank": "Ty: #%{rank} · %{score} respektu",
      "unranked": "Zdobądź respekt, żeby trafić na listę",
      "score": "%{score}",
      "empty": "Jeszcze nikogo tu nie ma. Bądź pierwszy!",
      "prizeInfo": "Top 3 każdego dnia wygrywa 30 / 20 / 10 Freak Points",
      "seasonPrize": "Top 3 miesiąca wygrywa 100 / 50 / 25 FP i medal"
    },
    "today": {
      "yesterday": "Wczoraj we Freakland",
      "freaks": "nowe freaki",
      "reels": "nowe rolki",
      "catches": "połowy",
      "busiest": "Najaktywniejsze",
      "topFreak": "Freak tygodnia",
      "likes": "Polubienia: %{count}",
      "champions": "Wczorajsi mistrzowie",
      "championPrize": "+%{points} FP",
      "events": "Co się dzieje",
      "noEvents": "Na razie cisza. Narób trochę hałasu!"
    },
    "friends": {
      "intro": "Zaproś znajomych — osoby, które obserwujesz i które obserwują Ciebie — do gry w The Freaks. Dostaną powiadomienie z Twoim zaproszeniem.",
      "invite": "Zaproś",
      "invitedToday": "Zaproszono",
      "invited": "Zaproszenie wysłane do @%{username} 🎮",
      "playing": "Gra w The Freaks",
      "notPlaying": "Jeszcze nie gra",
      "empty": "Nie masz jeszcze znajomych. Znajomi to osoby, które obserwujesz i które obserwują Ciebie.",
      "limit": "Każdego znajomego możesz zaprosić raz dziennie."
    },
    "events": {
      "mission": "ukończył(a): %{name}",
      "challengeWon": "pokonał(a) %{target}",
      "challengeLost": "przegrał(a) z %{target}",
      "gear": "kupił(a): %{name}",
      "base": "rozbudował(a) %{name} do poziomu %{level}",
      "champion": "był(a) wczoraj #%{rank} (+%{points} FP)",
      "medal": "zdobył(a) %{award} (%{season})",
      "badge": "zdobył(a) odznakę %{award}"
    },
    "results": {
      "missionWon": "%{name}: udało się! +%{cash} kasy, +%{respect} respektu",
      "missionFailed": "%{name}: tym razem nie wyszło",
      "missionInjured": "%{name}: kontuzja! Regeneracja %{minutes} min",
      "trained": "%{stat}: teraz %{value}",
      "gearBought": "%{name} jest Twój",
      "baseUpgraded": "%{name}: poziom %{level}",
      "collected": "+%{cash} kasy zebrane",
      "refilled": "+%{energy} energii",
      "recovered": "Wracasz do gry!",
      "dailyClaimed": "+%{cash} kasy, +%{energy} energii",
      "dailyPoints": "+%{points} Freak Points!",
      "challengeWon": "Pokonujesz %{opponent}! +%{cash} kasy, +%{respect} respektu",
      "challengeLost": "%{opponent} był(a) tym razem silniejszy(a)",
      "contextChanged": "Teraz grasz: %{context}",
      "missionRepeat": "%{name} ×%{runs}: %{wins} udanych, +%{cash} kasy, +%{respect} respektu",
      "questClaimed": "Zadanie wykonane! +%{cash} kasy, +%{respect} respektu",
      "repaired": "Baza naprawiona za %{cash} kasy",
      "deposited": "%{deposited} kasy w sejfie (opłata %{fee})",
      "withdrawn": "Wypłacono %{withdrawn} kasy z sejfu",
      "lootReduced": "Często go wyzywasz w tym tygodniu: %{percent}% łupu"
    },
    "errors": {
      "not_enough_energy": "Za mało energii. Poczekaj chwilę albo zjedz coś przy ognisku.",
      "not_enough_cash": "Za mało kasy",
      "recovering": "Jeszcze się regenerujesz",
      "locked": "Zdobądź więcej respektu, żeby to odblokować",
      "already_owned": "Już to masz",
      "max_level": "To już maksymalny poziom",
      "no_base": "Najpierw zbuduj bazę",
      "no_refills_left": "Na dziś koniec przekąsek",
      "energy_full": "Energia jest już pełna",
      "not_recovering": "Nie masz kontuzji",
      "target_protected": "Ten freak był już dziś wystarczająco wyzywany",
      "already_claimed": "Już dziś odebrane",
      "already_challenged": "Już dziś wyzwałeś tego freaka",
      "busy": "Za szybko! Spróbuj jeszcze raz",
      "already_invited": "Ten znajomy dostał już dziś zaproszenie — spróbuj jutro",
      "not_friends": "Możesz zapraszać tylko znajomych (obserwujecie się nawzajem)",
      "quest_not_done": "Najpierw ukończ zadanie",
      "unknown_quest": "To zadanie nie jest dziś dostępne",
      "no_repair_needed": "Twoja baza jest jak nowa",
      "safe_full": "Sejf jest pełny — zdobądź wyższy poziom, żeby zmieścić więcej",
      "not_enough_in_safe": "Nie masz tyle w sejfie",
      "invalid_amount": "Wybierz kwotę",
      "level_locked": "Zdobądź wyższy poziom, żeby to odblokować",
      "newcomer_bots_only": "Wciąż jesteś nowicjuszem: wyzywaj boty, dopóki trwa ochrona",
      "target_newcomer": "Ten freak jest nowicjuszem i na razie jest chroniony",
      "generic": "Coś poszło nie tak. Spróbuj ponownie."
    },
    "loadError": "Nie udało się wczytać The Freaks. Pociągnij, żeby spróbować ponownie.",
    "character": {
      "title": "Mój freak",
      "stage": "ETAP %{stage}/%{stages}",
      "next": "Dalej: %{name} na poz. %{level}",
      "legend": "Poziom 100 — ostateczny freak. Wyżej się już nie da!",
      "locked": "odblokujesz na poz. %{level}",
      "evolved": "🎉 Twój freak ewoluował w: %{name}!"
    }
  },
  "settings": {
    "theFreaksDailyNotification": "🎁 The Freaks: dzienna nagroda i mistrzowie",
    "theFreaksChallengeNotification": "🥊 The Freaks: wyzwania",
    "theFreaksInviteNotification": "🎮 The Freaks: zaproszenia od znajomych",
    "theFreaksOnProfile": "Pokazuj The Freaks na moim profilu",
    "theFreaksOnProfileDescription": "Twój poziom, miejsce w sezonie i bilans w sekcji Statystyki na profilu"
  }
};
